import { KText } from '@/ui-library/components/text';
import { Flex, Icon } from '@chakra-ui/react'; // Import Flex, Text, Icon from Chakra UI

export const FilterList = ({
  filtersConfig = [],
  handleFilterListOnclick = () => {},
}) => {
  return (
    <Flex flexDir="column" gap=".5em">
      {filtersConfig?.map((filter, index) => {
        const { id, label, icon, description } = filter || {};
        return (
          <Flex
            key={id || index}
            onClick={() => handleFilterListOnclick(filter)}
            alignItems="center"
            p="4px 12px"
            gap="6px"
            _hover={{ background: 'secondary-50' }}
            borderRadius="6px"
            cursor="pointer"
            minW="max-content"
          >
            {icon && <Icon as={icon} color="secondary-700" />}
            <KText fontSize="sm">{label}</KText>

            {/* need to confirm description design from design team */}
            {description && <KText fontSize="sm">{description} </KText>}
          </Flex>
        );
      })}
    </Flex>
  );
};
